import React from 'react';
const SideImage = () => <span className='search-customer__side-image-styles' role='img' aria-label='DHL_aviation' />;

export default SideImage;
